<template>
    <div class="d-flex flex-column" id="p_simposium">
        <v-overlay :value="isPageLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row ref="headerFilters">
            <data-table-filters v-if="!isMobile"
                name="Simposium Veterinário"
                :has-active-filters="hasActiveFilters"
                :are-advanced-filters-active="areAdvancedFiltersActive"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :advanced_filters="advanced_filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                @apply-advanced-filters="applyAdvancedFilters"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    name="Simposium Veterinário"
                    :has-active-filters="hasActiveFilters"
                    :are-advanced-filters-active="areAdvancedFiltersActive"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    :filters="filters"
                    :advanced_filters="advanced_filters"
                    :schema="tSchema(schema)"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh"
                    @clear-filters="onClearFilters()"
                    @apply-advanced-filters="applyAdvancedFilters"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col cols="12">
                <pure-datatable endpoint="/api/products/simposium" @data-changed="onDataChanges" :queryParams="queryParams" :ready="ready" :customSearch="customSearch" ref="datatable" v-slot:default="{ vOn, vBind, updateOptions, isLoading }">
                    <div>
                        <portal to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="simposium"
                            class="elevation-1 d-flex flex-column justify-space-between nowrap-headers datatable-simposium"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :headers="tHeaders(headers)"
                            :hide-default-headers="isMobile"
                            :class="{mobile: isMobile}"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :header-props="headerProps"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions:  itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                        >
                            <template v-if="!isMobile" #[`header.has_campaign`]="scope">
                                <v-icon style="left: 10%">mdi-star-outline</v-icon>
                            </template>

                            <template v-if="!isMobile" #[`item.designation`]="scope">
                                <div class="d-flex justify-start align-center" data-cy="designations">
                                    <!--<product-image :is-new="!!scope.item.new" :productCode="scope.item.invoice_code" :imageSrc="scope.item.image" width="35" height="35" max-width="35" max-height="35" style="cursor: pointer; position: relative" @click="openProductDetails(scope.item)">
                                    </product-image>-->
                                    <div class="datatable-new" v-if="scope.item.new">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-on="on" v-bind="attrs">mdi-new-box</v-icon>
                                            </template>
                                            <span>{{ $t('orders.base.newProduct') }}</span>
                                        </v-tooltip>
                                   </div>
                                   <div class="datatable-video" v-if="scope.item.has_video">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-on="on" v-bind="attrs"> mdi-youtube</v-icon>
                                            </template>
                                            <span>{{ $t('orders.base.featuredVideo') }}</span>
                                        </v-tooltip>
                                   </div>
                                    <div class="datatable-image">
                                        <div class="image-product-list" :style="'background-image: url('+scope.item.thumbnail+');'"
                                        @click="openProductDetails(scope.item)">
                                        </div>
                                    </div>

                                    <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(scope.item)">
                                        {{ scope.item.designation }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.extraIcons`]="scope">
                                <product-additional-info :product="scope.item"> </product-additional-info>
                            </template>

                            <template v-if="!isMobile" #[`item.active_substances__description`]="scope">
                                <div class="datatable-multi-line-text">
                                    <span v-for="(item, index) in scope.item.active_substances" :key="index">
                                        {{ item.description }}<template v-if="index !== scope.item.active_substances.length - 1"><br /></template>
                                    </span>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.laboratory__name`]="scope">
                                {{ scope.item.laboratory.name }}
                            </template>

                            <template v-if="!isMobile" #[`item.species__description`]="scope">
                                <div class="datatable-multi-line-text">
                                    <span v-for="(item, index) in scope.item.species" :key="index"> {{ item.description }}<template v-if="index !== scope.item.species.length - 1">, </template> </span>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.administration_route__description`]="scope">
                                <span v-if="scope.item.administration_route">
                                    {{ scope.item.administration_route.description }}
                                </span>
                            </template>

                            <template v-if="!isMobile" #[`item.pharma_composition__description`]="scope">
                                <div v-if="scope.item.pharma_composition" class="datatable-multi-line-text">
                                    {{ scope.item.pharma_composition.description }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.has_campaign`]="scope">
                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns && !scope.item.hide_shopping_button && !normalOrderStore.checkIfPubArticle(scope.item)">
                                    <campaign-tooltip v-if="productHasActiveCampaign(scope.item.id) && !normalOrderStore.checkIfPubArticle(scope.item)" isOutlined :text="$t('orders.base.campaignApplied')" @click="onClickProductCampaign(scope.item)"></campaign-tooltip>
                                    <campaign-tooltip v-else-if="!productHasActiveCampaign(scope.item.id) && scope.item.has_campaign && !normalOrderStore.checkIfPubArticle(scope.item)" :text="$t('orders.base.withCampaign')" @click="onClickProductCampaign(scope.item)"></campaign-tooltip>
                                </template>
                            </template>

                            <template v-if="!isMobile" #[`item.actions`]="scope">
                                <div class="d-flex justify-end d-flex align-center">
                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(scope.item)"> mdi-dots-horizontal-circle-outline </v-icon>
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                            <tr>
                                <v-card
                                    elevation="2"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col  class="col col-3 pt-0 pb-0">
                                                   <!--<product-image :productCode="item.invoice_code" :imageSrc="item.image" :is-new="!!item.new" width="84" height="84" max-width="84" max-height="84" style="cursor: pointer; position: relative" @click="openProductDetails(item)"></product-image>-->
                                                    <div class="datatable-image">
                                                        <div class="image-product-list" :style="'background-image: url('+item.thumbnail+');'"
                                                        @click="openProductDetails(item)">
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col  class="col col-9 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item)">
                                                                {{ item.designation }}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-lable-text laboratory">
                                                                {{ item.laboratory.name}}
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-12 pt-0 pb-0 stock">
                                                            <product-additional-info :product="item"> </product-additional-info>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0">
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0">
                                                            <div class="d-flex justify-end align-center">
                                                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns && !item.hide_shopping_button && !normalOrderStore.checkIfPubArticle(item)">
                                                                    <campaign-tooltip v-if="productHasActiveCampaign(item.id) && !normalOrderStore.checkIfPubArticle(item)" isOutlined :text="$t('orders.base.campaignApplied')" @click="onClickProductCampaign(item)"></campaign-tooltip>
                                                                    <campaign-tooltip v-else-if="!productHasActiveCampaign(item.id) && item.has_campaign && !normalOrderStore.checkIfPubArticle(item)" :text="$t('orders.base.withCampaign')" @click="onClickProductCampaign(item)"></campaign-tooltip>
                                                                </template>
                                                                <div class="datatable-new" v-if="item.new">
                                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-icon v-on="on" v-bind="attrs">mdi-new-box</v-icon>
                                                                            </template>
                                                                            <span>{{ $t('orders.base.newProduct') }}</span>
                                                                    </v-tooltip>
                                                                </div>
                                                                <div class="datatable-video" v-if="item.has_video">
                                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                <v-icon v-on="on" v-bind="attrs"> mdi-youtube</v-icon>
                                                                        </template>
                                                                        <span>{{ $t('orders.base.featuredVideo') }}</span>
                                                                        </v-tooltip>
                                                                </div>
                                                                <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(item)" data-cy="product-details"> mdi-dots-horizontal-circle-outline </v-icon>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                 </v-col>
                                                 <v-row class="d-flex align-start pt-0 pb-0 mt-2">
                                                    <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('products.upper.activeIngredient') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('products.upper.species') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('products.upper.adminRoute') }}</v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field invoices">{{ $t('products.upper.pharmClass') }}</v-col>
                                                    </v-col>
                                                    <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <!--<div class="datatable-multi-line-text">
                                                                <span v-for="(item, index) in item.active_substances" :key="index">
                                                                    {{ item.description }}<template v-if="index !== item.active_substances.length - 1"><br /></template>
                                                                </span>
                                                            </div>-->

                                                                <div class="datatable-designation-text" v-if="item.active_substances.length">
                                                                    <span v-for="(item2, index2) in item.active_substances" :key="index2">
                                                                        {{ item2.description }}<span v-if="index2 !== item.active_substances.length - 1">, </span>
                                                                    </span>
                                                               </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                <span v-for="(item3, index3) in item.species" :key="index3"> {{ item3.description }}<span v-if="index3 !== item.species.length - 1">, </span> </span>
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                <span v-if="item.administration_route">
                                                                        {{ item.administration_route.description }}
                                                                    </span>
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                            <div class="datatable-designation-text">
                                                                <span v-if="item.pharma_composition">
                                                                    {{ item.pharma_composition.description }}
                                                                </span>
                                                            </div>
                                                        </v-col>
                                                    </v-col>
                                                 </v-row>
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </tr>

                        </template>

                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="canExport()" :scope="scope" @export="exportData" @updateOptions="updateOptions" :isLoading="isLoading" :showOrderButton="false" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>

        <product-campaign-form :isMobile="isMobile"
            v-if="isDetailedCampaignDialogOpen"
            :key="selectedProduct.id"
            :isOpen="isDetailedCampaignDialogOpen"
            :product="selectedProduct"
            :campaigns="manipulatedProductCampaigns"
            :account-blocked-message="accountBlockedMessage"
            @input="onCloseDetailedCampaignDialog()"
            @input-remove-campaign="tryRemoveCampaign($event)"
            @check-applied-campaigns="checkAppliedCampaigns()"
            @create-new-original-campaign="createNewOriginalCampaign($event)"
            @show-campaigns="onClickProductCampaign"
        ></product-campaign-form>

        <app-dialog v-if="isProductDetailsDialogOpen" :isProductDetails="true" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" :title="$t('orders.base.productSheet')" width="55vw" :isResponsive="true" :showActions="false">
            <template v-slot:content>
                <product-details :product="selectedProduct" :key="selectedProduct.id" @change-product="changeProduct" @show-campaigns="onClickProductCampaign"></product-details>
            </template>
        </app-dialog>

        <confirmation-dialog :value="isRemoveCampaignDialogOpen" @onSuccess="acceptedRemoveCampaign()" @onCancel="isRemoveCampaignDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.base.removeCampaignQuestion')"> </confirmation-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import { useAppStore } from '@/Stores/app';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { axios } from '@/Services/Backend';
import PureDatatable from '@arentia/atools/PureDatatable';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        advanced_filters: Array,
        accountBlockedMessage: String,
    },

    data: () => ({
        isPageLoading: false,
        isLoading: false,

        datatableSize: 200,
        resizeObserver: null,

        filters: {},
        queryParams: {},
        ready: false,
        hasExpandedActiveFilters: false,

        endpointCampaigns: '/api/campaigns',
        selectedProduct: {},

        productCampaigns: [],
        originalProductCampaigns: [],
        manipulatedProductCampaigns: [],

        isDetailedCampaignDialogOpen: false,
        isProductDetailsDialogOpen: false,
        isFileFormatsDialogOpen: false,

        isRemoveCampaignDialogOpen: false,

        // Shipping conditions
        onAcceptedCallback: null,

        areAdvancedFiltersActive: false,
        advancedFilters: {
            logicalOperator: 'all',
            children: [],
        },
        itemsPerPageOptions:window.innerWidth>=768&&window.innerWidth<=1366?[20,40,50,100]:[20,40,50],
        customSearch: {
            designation: `{
                "type": "query-builder-group",
                "query": {
                    "logicalOperator": "any",
                    "children": [
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "designation",
                                "operator": "keywords",
                                "operand": "designation",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "code",
                                "operator": "contains",
                                "operand": "code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "ean",
                                "operator": "contains",
                                "operand": "ean",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "invoice_code",
                                "operator": "contains",
                                "operand": "invoice_code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "laboratory.name",
                                "operator": "contains",
                                "operand": "laboratory.name",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "species.description",
                                "operator": "contains",
                                "operand": "species.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "pharma_composition.description",
                                "operator": "contains",
                                "operand": "pharma_composition.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "active_substances.description",
                                "operator": "contains",
                                "operand": "active_substances.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "administration_route.description",
                                "operator": "contains",
                                "operand": "administration_route.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "range.description",
                                "operator": "contains",
                                "operand": "range.description",
                                "value": "__designation__"
                            }
                        }
                    ]
                }
            }`,
        },
    }),

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;

                this.ready = true;
                this.refresh();
            },
            immediate: true,
        },
        isDetailedCampaignDialogOpen: {
            handler: function (value) {
                if (!value) {
                    useNormalOrderStore().clearAllOldCarts(this.userStore.user.id, this.branchStore.branch.id, ['baseCampaigns'],true);
                }
            }
            //immediate: true,
        }
    },

    created() {
        this.applyDefaultFilters();
    },

    mounted() {
        this.prepareResponsiveBehaviour();
        this.refresh();
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
                 this.refreshDeely()
        })
        this.checkHeaders();
        window.EventBus.$on('update:product-search', (e) => {
            //console.log('product-search',e)
            this.setSearchByCamera(e)
        })
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
        window.EventBus.$off('update:product-search', null)
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore, useNormalOrderStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        branchNoCampaigns() {
            return this.branchStore.hideCampaigns;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        setSearchByCamera(searchTerm){
            //this.$set(this.model, 'designation', searchTerm);
            this.$set(this.filters, 'designation', searchTerm);
            this.refresh()
        },
        checkHeaders(){
            let windowWidth = window.innerWidth;
            if (windowWidth <= 600) {
                _.each(this.headers,(o)=>{
                    if(o.value=='has_campaign'){
                        o.text='Campanha'
                    }
                })
            }else{
                _.each(this.headers,(o)=>{
                    if(o.value=='has_campaign'){
                        o.text=''
                    }
                })
            }
        },
        setItemsPorPage(){
            this.itemsPerPageOptions=window.innerWidth>=768&&window.innerWidth<=1366?[20,40,50,100]:[20,40,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        canExport() {
            return this.userStore.hasPermissionTo('Export simposium');
        },

        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - 75 - topHeight;
                this.datatableSize = res;
            }
        },

        changeProduct(newProduct) {
            this.selectedProduct = newProduct;
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);

            this.onFiltersChanged();
        },
        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged()
                }
            }else{
                this.setFiltersChanged()
            }
        },
        setFiltersChanged(){
                this.refresh();
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },

        setFieldsDisabledStateTo(bool) {
            for (const key in this.schema) {
                this.schema[key].disabled = bool;
            }
        },

        applyAdvancedFilters(advancedFilters) {
            this.clearNormalFilters();
            this.areAdvancedFiltersActive = true;

            const baseQueryBuilder = {
                logicalOperator: 'all',
                children: [
                    {
                        type: 'query-builder-group',
                        query: advancedFilters,
                    },
                ],
            };

            this.advancedFilters = baseQueryBuilder;

            // Disable the basic filters if the advanced filters are active.
            this.setFieldsDisabledStateTo(true);

            this.refresh();
        },

        refresh(options) {
            if (!this.branchStore.branch) return;

            const query = this.areAdvancedFiltersActive ? this.advancedFilters : this.filters;

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                    options=this.$refs.datatable.localOptions
                    if(window.innerWidth<=768){
                        options.itemsPerPage=20
                    }else{
                        options.itemsPerPage=20
                    }
                   //options.itemsPerPage=window.innerWidth>=768&&window.innerWidth<=1366?20:10
                    this.$refs.datatable.setLocalOptions(options);
                }
                this.$refs.datatable.onChangeQueryBuilder(query, this.schema);
            }
        },

        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        clearNormalFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            // Enable the basic filters if the advanced filters are not active.
            this.setFieldsDisabledStateTo(false);

            this.refresh();
        },

        onClearFilters() {
            this.areAdvancedFiltersActive = false;
            this.clearNormalFilters();
        },

        onClickProductCampaign(product) {
            this.isPageLoading = true;

            // Close the dialog if it's currently open with another campaign
            if (this.isProductDetailsDialogOpen) this.isProductDetailsDialogOpen = false;
            if (this.isDetailedCampaignDialogOpen) this.isDetailedCampaignDialogOpen = false;

            const targetData = {
                branch_id: this.branchStore.branch?.id,
                product_code: product.code,
            };

            // Obtain fresh data for the product that was used for the latest campaigns dialog trigger
            axios.post('/api/products/single/', targetData).then(({ data }) => {
                this.selectedProduct = data[0];
                this.getCampaigns();
            });
        },

        exportData() {
            if (!this.branchStore.branch || !this.$refs.datatable) return;

            const axiosSettings = {
                url: '/api/products/simposium/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable.exportData(axiosSettings, 'export_simposium');
        },

        getCampaigns() {
            this.isPageLoading = true;
            axios
                .get(this.endpointCampaigns, {
                    params: {
                        reference: this.selectedProduct.code,
                        branch_id: this.branchStore.branch?.id,
                        campaign_id: this.selectedProduct.campaign_id,
                    },
                })
                .then((response) => {
                    this.isPageLoading = false;

                    let results=response.data
                    _.each(results,(elem)=>{
                        if(elem.description==null){
                            if(elem.offer_quantity>0){
                                let target = String(this.selectedProduct.code);
                                let requirement = _.find(elem.requirements, r => String(r.referenceable) === target);
                                //let requirement = _.find(elem.requirements,{referenceable:''+this.selectedProduct.code})
                                let baseQty = requirement?requirement.min_quantity:elem.requirements[0].min_quantity;
                                let offerQty = elem.offer_quantity
                                if(requirement){
                                    if(!requirement.obs){
                                         elem.description = 'NA COMPRA DE '+baseQty+' UNI, '+offerQty+' DE OFERTA'
                                    }
                                }else{
                                    elem.description = 'NA COMPRA DE '+baseQty+' UNI, '+offerQty+' DE OFERTA'
                                }
                            }
                        }
                    })
                    this.productCampaigns =results;
                    this.originalProductCampaigns = JSON.parse(JSON.stringify(this.productCampaigns));

                    if (this.productCampaigns.length == 0) {
                        this.showError(this.$t('orders.base.campaignsUnavailable'));
                    } else {
                        this.checkAppliedCampaigns();
                        this.isDetailedCampaignDialogOpen = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isPageLoading = false;
                });
        },

        handleStoredMixCampaigns() {
            // Check if there are stored mixs to show
            // We don't want to get the simple campaigns where the originating product id is 999999
            let campaigns = [];
            const all_stored_campaigns = this.normalOrderStore.getCampaignsWithoutSimpleCampaigns;

            if (all_stored_campaigns.length > 0) {
                this.productCampaigns.forEach((campaign) => {
                    const stored_campaigns = all_stored_campaigns.filter((sc) => {
                        return sc.id === campaign.id;
                    });

                    if (stored_campaigns.length > 0) {
                        stored_campaigns.forEach((stored_campaign) => {

                           if(_.size(campaign.requirements) > _.size(stored_campaign.requirements)){
                                 let clone = _.cloneDeep(campaign)
                                 _.each(clone.requirements,(req)=>{
                                    if(_.findIndex(stored_campaign.requirements,{referenceable:req.referenceable})===-1 && !campaign.split_promotion){
                                        req.campaign_unique_id = stored_campaign.unique_id
                                        req.originating_product.campaign_unique_id = stored_campaign.unique_id
                                        req.product.campaign_unique_id = stored_campaign.unique_id
                                        stored_campaign.requirements.push(req)
                                    }
                                 })
                           }
                           campaigns.push(stored_campaign);
                        });
                    } else {
                        campaigns.push(campaign);
                    }
                });
            }
            this.manipulatedProductCampaigns =
                campaigns.length > 0 //
                    ? campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index)
                    : this.productCampaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        checkAppliedCampaigns() {
            let campaigns = [];

            this.handleStoredMixCampaigns();
            this.normalOrderStore.restoreBaseCampaigns(this.productCampaigns);

            this.manipulatedProductCampaigns.forEach((campaign) => {
                let finalCampaign;

                let storedCampaign = this.normalOrderStore.getCampaignByUniqueIdAndProduct(campaign.unique_id, this.selectedProduct.id);
                if (storedCampaign) {
                    finalCampaign = storedCampaign;
                } else {
                    let storedCampaignFromAnotherRequirement = this.normalOrderStore.getCampaignByUniqueId(campaign.unique_id);

                    if (storedCampaignFromAnotherRequirement && storedCampaignFromAnotherRequirement.unique_id == campaign.unique_id) {

                        if(campaign.split_promotion && campaign.is_purchased_product_offer && campaign.amount_of_requirements_needed==1){

                            let hasCampaignStored = _.find(this.manipulatedProductCampaigns,{unique_id:campaign.unique_id})
                            let indexCampaign = _.findLastIndex(this.manipulatedProductCampaigns,{id:campaign.id})
                            let lastIndexCampaign = 0
                            let nextIndexCampaign = 0

                            if(indexCampaign == -1){
                                lastIndexCampaign = 0
                            }else{
                                let lastUniqueId = this.manipulatedProductCampaigns[indexCampaign].unique_id
                                let splitLastId = _.split(lastUniqueId,'_')
                                if(_.size(splitLastId)){
                                    lastIndexCampaign = parseInt(splitLastId[1])
                                }
                                nextIndexCampaign = lastIndexCampaign + 1
                            }

                            let groupCampaigns = _.filter(this.manipulatedProductCampaigns,{id:campaign.id})
                            let setNewCamp = false

                            if(hasCampaignStored){
                                if(hasCampaignStored.unique_id == campaign.id + '_' + lastIndexCampaign){
                                    setNewCamp  = !_.some(groupCampaigns, group =>
                                        _.some(group.requirements, r => r.referenceable == '' + this.selectedProduct.code)
                                    );
                                }
                            }

                            if(setNewCamp){

                                let newStoredCampaign = _.cloneDeep(storedCampaignFromAnotherRequirement)
                                newStoredCampaign.unique_id = campaign.id + "_" + nextIndexCampaign
                                if(campaign.is_purchased_product_offer){
                                    newStoredCampaign.offers = []
                                }
                                newStoredCampaign.in_shopping_cart = false
                                let getCampaignReq = _.find(this.productCampaigns,{id:campaign.id})
                                newStoredCampaign.requirements = getCampaignReq.requirements

                                _.each(newStoredCampaign.requirements, (req) => {
                                    req.campaign_unique_id = campaign.id + "_" + nextIndexCampaign
                                    req.product.campaign_unique_id = campaign.id + "_" + nextIndexCampaign
                                })
                                finalCampaign = newStoredCampaign
                            }

                        }else{
                            if(!campaign.split_promotion)
                              finalCampaign = storedCampaignFromAnotherRequirement;
                        }

                    } else {
                        finalCampaign = JSON.parse(JSON.stringify(this.originalProductCampaigns.find((c) => c.id === campaign.id)));
                    }
                }

                if (!finalCampaign || typeof finalCampaign !== 'object') return;

                if (!Array.isArray(finalCampaign.requirements)) {
                    finalCampaign.requirements = [];
                }

                // Add requirements with no quantity from baseCampaigns
                const baseCampaign = this.normalOrderStore.getBaseCampaignByUniqueId?.(campaign.unique_id);

                if (baseCampaign) {
                    if(!campaign.split_promotion){
                        const currentRequirements = Array.isArray(finalCampaign.requirements) ? finalCampaign.requirements : [];
                        const existingRequirementIds = currentRequirements.map((r) => r?.product?.id ?? null).filter((id) => id !== null);

                        const missingRequirements = baseCampaign.requirements.filter((req) => {
                            return !existingRequirementIds.includes(req.product.id);
                        });

                        finalCampaign.requirements.push(...missingRequirements);
                        //finalCampaign.requirements.sort((a, b) => a.product.id - b.product.id);
                    }
                }

                campaigns.push(finalCampaign);
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },

        onCloseDetailedCampaignDialog() {
            this.isDetailedCampaignDialogOpen = false;
        },

        openProductDetails(product) {
            this.selectedProduct = product;
            this.isProductDetailsDialogOpen = true;
        },

        isInCart(product) {
            const item = this.normalOrderStore.getProduct(product.id);
            return item !== undefined;
        },

        onDataChanges(value) {
            // If the product is in the cart, we want to change the quantities accordingly.
            for (const [index, product] of value?.data?.entries()) {
                if (this.isInCart(product)) {
                    const item = { ...this.normalOrderStore.getProduct(product.id) };
                    item.has_campaign = product.has_campaign;
                    this.$set(value.data, index, item);
                }
            }

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        tryRemoveCampaign(product, isIncrement = null) {
            this.selectedProduct = product;
            const campaign = this.normalOrderStore.getCampaignForOriginatingProduct(product.originating_product_id);
            const fulfilledRequirements = [];

            for (const requirement of campaign.requirements) {
                if (!requirement.product.quantity) continue; // didn't buy in to this requirement.
                fulfilledRequirements.push(requirement);
            }

            if (campaign.amount_of_requirements_needed > 0 && fulfilledRequirements.length > campaign.amount_of_requirements_needed) {
                if (isIncrement === null) product.quantity = 0;
                this.normalOrderStore.changeCampaignQuantityOnExisting(product.campaign_unique_id, product.index, isIncrement);
            } else {
                this.isRemoveCampaignDialogOpen = true;
            }
        },

        acceptedRemoveCampaign() {
            if (this.isDetailedCampaignDialogOpen) this.isDetailedCampaignDialogOpen = false;
            this.remove(this.selectedProduct);
        },

        remove(item) {
            if ('campaign_id' in item) {
                this.normalOrderStore.removeCampaign(item.campaign_unique_id, item.id);
                this.isRemoveCampaignDialogOpen = false;
            } else {
                this.normalOrderStore.removeProduct(item.id);
            }
        },

        productHasActiveCampaign(productId) {
            return this.normalOrderStore.hasActiveCampaign(productId);
        },
        createNewOriginalCampaign(campaign) {
            let campaigns = [];

            const newOriginalCampaign = () => {
                const originalCampaign = this.originalProductCampaigns.find((c) => {
                    return c.id == campaign.id;
                });

                if (!originalCampaign) return false;

                const maxIndexCampaign = this.manipulatedProductCampaigns.filter((c) => c.id === campaign.id).reduce((prev, current) => (prev && prev.index > current.index ? prev : current));

                let oc = originalCampaign;
                oc.index = maxIndexCampaign.index + 1;
                oc.unique_id = oc.id + '_' + oc.index;

                // Manipulate requirements unique_id
                oc.requirements.forEach((requirement, index) => {
                    requirement.campaign_unique_id = oc.unique_id;
                    requirement.product.campaign_unique_id = oc.unique_id;
                    requirement.product.uniqueId = requirement.product.id + '_' + oc.unique_id + '_header_' + index;
                });

                // Manipulate requirements unique_id
                oc.offers.forEach((offer, index) => {
                    offer.campaign_unique_id = oc.unique_id;
                    offer.product.campaign_unique_id = oc.unique_id;
                    offer.product.uniqueId = offer.product.id + '_' + oc.unique_id + '_offer_' + index;
                });

                return oc;
            };

            this.manipulatedProductCampaigns.forEach((manipulatedCampaign) => {
                campaigns.push(manipulatedCampaign);

                if (manipulatedCampaign.unique_id === campaign.unique_id) {
                    campaigns.push(JSON.parse(JSON.stringify(newOriginalCampaign())));
                }
            });

            this.manipulatedProductCampaigns = campaigns.sort((a, b) => a.sort - b.sort || a.index - b.index);
        },
    },
};
</script>

<style>
.max-pagination-height > .v-pagination {
    height: 24px !important;
}
.max-pagination-height > .v-pagination .v-pagination__item {
    font-size: 12px !important;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}

#form-base > div > .v-input > .v-input__control > .v-input__slot .v-input__icon--prepend-inner button.v-icon {
    color: #154579;
    font-size: 18px !important;
}
</style>
